<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="closePanel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text">
            Detalle del producto {{ product.product ? product.product.name : '' }}
          </div>
        </div>
        <div>
          <div>
            <v-row>
              <v-col md="12">
                <v-form ref="form" v-model="form.valid">
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        v-model="taxKind"
                        rounded
                        outlined
                        dense
                        hide-selected
                        hide-details
                        :items="taxes"
                        item-value="name"
                        item-text="name"
                        return-object
                        @change="selectTaxKind"
                        :rules="[rules.required]"
                        :label="$t('products.labels.tax')"
                        :placeholder="$t('products.placeholders.tax')"/>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="form.data.isRetention"
                        rounded
                        outlined
                        dense
                        hide-selected
                        hide-details
                        :items="taxKinds"
                        item-text="name"
                        item-value="value"
                        :disabled="form.disabled.isRetention"
                        :rules="[rules.required]"
                        :label="$t('products.labels.taxKind')"
                        :placeholder="$t('products.placeholders.taxKind')"/>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="form.data.isQuota"
                        rounded
                        outlined
                        dense
                        hide-selected
                        hide-details
                        :items="taxTypes"
                        item-text="name"
                        item-value="value"
                        :disabled="form.disabled.isQuota"
                        :rules="[rules.required]"
                        :label="$t('products.labels.taxType')"
                        :placeholder="$t('products.placeholders.taxType')"/>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model.number="form.data.base"
                        rounded
                        outlined
                        dense
                        hide-details
                        :disabled="form.disabled.base"
                        :rules="[rules.required, rules.numeric]"
                        :label="$t('products.labels.taxBase')"
                        :placeholder="$t('products.placeholders.quantity')"/>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model.number="form.data.baseAmount"
                        rounded
                        outlined
                        dense
                        hide-details
                        :disabled="form.disabled.baseAmount"
                        :rules="[rules.required, rules.numeric]"
                        :label="$t('products.labels.taxAmount')"
                        :placeholder="$t('products.placeholders.quantity')"/>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-end">
                      <v-btn
                        v-if="form.isEditing"
                        class="mr-2"
                        small
                        rounded
                        depressed
                        outlined
                        color="primary"
                        @click="cancel">
                        {{ $t('products.labels.cancel') }}
                      </v-btn>
                      <v-btn
                        small
                        rounded
                        depressed
                        color="primary"
                        @click="submit">
                        {{ $t(form.isEditing ? 'products.labels.editTaxes' : 'products.labels.addTaxes') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
              <v-col md="12">
                <v-data-table
                  :loading-text="table.title"
                  :loading="table.loading"
                  :headers="table.headers"
                  :items="product.taxes"
                  :items-per-page="table.itemsPerPage"
                  :page="table.page"
                  hide-default-footer
                  dense
                  class="elevation-1">
                  <template v-slot:item.isRetention="{ item }">
                    <div class="text-right">
                      {{ item.isRetention ? 'Retenido' : 'Trasladado' }}
                    </div>
                  </template>
                  <template v-slot:item.isQuota="{ item }">
                    <div class="text-right">
                      {{ item.isQuota ? 'Cuota' : 'Tasa' }}
                    </div>
                  </template>
                  <template v-slot:item.base="{ item }">
                    <div class="text-right">
                      {{ item.base | toFixNumber(2) | numberWithComma }}
                    </div>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <div class="d-flex">
                      <v-btn
                        x-small
                        fab
                        depressed
                        text
                        class="mr-2"
                        color="primary"
                        @click="editTax(item)">
                        <v-icon small>mdi-border-color</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        fab
                        depressed
                        text
                        class="mr-2"
                        color="error"
                        @click="openRemoveDialog(item)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('ingredients.actions.remove', { name: taxToRemove.name }) }}</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="closeRemoveDialog">{{ $t('messages.no') }}</v-btn>
          <v-btn color="black darken-1" text @click="remove">{{ $t('messages.yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { required, numeric, string } from 'vue-mc/validation'

export default {
  name: 'Taxes',
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      overlay: false,
      removeDialog: false,
      taxToRemove: {},
      table: {
        title: this.$i18n.t('products.sidePanel.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('products.sidePanel.headers.kind'), value: 'kind' },
          { text: this.$i18n.t('products.sidePanel.headers.isRetention'), value: 'isRetention' },
          { text: this.$i18n.t('products.sidePanel.headers.isQuota'), value: 'isQuota' },
          { text: this.$i18n.t('products.sidePanel.headers.base'), value: 'base' },
          { text: this.$i18n.t('products.sidePanel.headers.baseAmount'), value: 'baseAmount' },
          { text: this.$i18n.t('products.sidePanel.headers.action'), value: 'action' }
        ],
        data: [],
        total: 0,
        itemsPerPage: 15,
        page: 1
      },
      form: {
        valid: false,
        data: {
          name: null,
          satCode: null,
          kind: null,
          isRetention: false,
          isQuota: false,
          base: 0
        },
        disabled: {
          isRetention: false,
          isQuota: false,
          base: false,
          baseAmount: false
        },
        isEditing: false
      },
      rules: {
        required,
        numeric,
        string
      },
      searchRecipe: '',
      taxes: [
        { satId: '001', name: 'ISR' },
        { satId: '002', name: 'IVA' },
        { satId: '002', name: 'IVA Exento' },
        { satId: '003', name: 'IEPS' }
      ],
      taxKinds: [
        { name: 'Trasladado', value: false },
        { name: 'Retenido', value: true }
      ],
      taxKind: null,
      taxTypes: [
        { name: 'Cuota', value: true },
        { name: 'Tasa', value: false }
      ]
    }
  },
  watch: {
    'form.data': {
      handler (val) {
        if (val.satCode === '003' && val.isQuota) {
          this.form.disabled.baseAmount = true
          this.form.data.baseAmount = 1
        }
      },
      deep: true
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.resetForm()
        this.$emit('closed', false)
      }
    },
    selectTaxKind (tax) {
      this.form.data.name = tax.name
      this.form.data.kind = tax.name
      this.form.data.satCode = tax.satId

      if (tax.satId === '001') {
        this.form.data.isRetention = true
        this.form.data.isQuota = false
        this.form.disabled.isRetention = true
        this.form.disabled.isQuota = true
        this.form.disabled.base = false
        this.form.disabled.baseAmount = false
      }

      if (tax.satId === '002') {
        this.form.data.isRetention = false
        this.form.data.isQuota = false
        this.form.disabled.isRetention = false
        this.form.disabled.isQuota = true
        this.form.disabled.base = false
        this.form.disabled.baseAmount = false
      }

      if (tax.name === 'IVA Exento') {
        this.form.data.isRetention = false
        this.form.data.isQuota = false
        this.form.data.base = 0
        this.form.disabled.isRetention = true
        this.form.disabled.isQuota = true
        this.form.disabled.base = true
        this.form.disabled.baseAmount = true
      }

      if (tax.satId === '003') {
        this.form.data.isRetention = false
        this.form.data.isQuota = false
        this.form.data.base = 0
        this.form.disabled.isRetention = true
        this.form.disabled.isQuota = false
        this.form.disabled.base = false
        this.form.disabled.baseAmount = false
      }
    },
    resetForm () {
      if (this.$refs.form) this.$refs.form.resetValidation()

      this.form.data = {
        name: null,
        satCode: null,
        kind: null,
        isRetention: false,
        isQuota: false,
        base: 0,
        baseAmount: 0
      }

      this.form.disabled = {
        isRetention: false,
        isQuota: false,
        base: false
      }

      this.taxKind = null

      this.form.isEditing = false
    },
    submit: async function () {
      this.$refs.form.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          const request = (this.form.isEditing)
            ? this.$api.put(`/v1/catalog/${this.product._id}/taxes/${this.form.data._id}`, this.form.data)
            : this.$api.post(`/v1/catalog/${this.product._id}/taxes`, this.form.data)
          const response = await request
          const product = Object.assign({}, this.product)
          product.taxes = response.taxes
          this.resetForm()
          this.$emit('updated', product)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    openRemoveDialog (item) {
      this.taxToRemove = item
      this.removeDialog = true
    },
    closeRemoveDialog () {
      this.taxToRemove = {}
      this.removeDialog = false
    },
    editTax (item) {
      this.taxKind = {
        satId: item.satCode,
        name: item.kind
      }

      this.selectTaxKind(this.taxKind)

      this.form.data = {
        _id: item._id,
        name: item.name,
        kind: item.kind,
        satCode: item.satCode,
        isRetention: item.isRetention,
        isQuota: item.isQuota,
        base: item.base,
        baseAmount: item.baseAmount
      }

      this.form.isEditing = true
    },
    cancel () {
      this.resetForm()
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/catalog/${this.product.id}/taxes/${this.taxToRemove._id}`)
        const product = Object.assign({}, this.product)
        product.taxes = this.product.taxes.filter(tax => tax._id !== this.taxToRemove._id)
        this.$emit('updated', product)
        this.closeRemoveDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    closePanel () {
      this.resetForm()
      this.$emit('closed', false)
    },
    calculateCost (item) {
      return item.recipe.cost * item.quantity
    }
  }
}
</script>
